const mageCards = [
  { rarity: "epic", mana: 7, name: "Ball Lightning" },
  { rarity: "epic", mana: 5, name: "Blizzard" },
  { rarity: "rare", mana: 2, name: "Book of Nightmares" },
  { rarity: "uncommon", mana: 1, name: "Bookworm" },
  { rarity: "uncommon", mana: 0, name: "Cauterize" },
  { rarity: "rare", mana: 3, name: "Chain Lightning" },
  { rarity: "uncommon", mana: 1, name: "Charge Battery" },
  { rarity: "rare", mana: 1, name: "Clear Instructions" },
  { rarity: "rare", mana: 1, name: "Cold Snap" },
  { rarity: "rare", mana: 3, name: "Combustion" },
  { rarity: "mythic", mana: 2, name: "Cursenomicon" },
  { rarity: "common", mana: 2, name: "Curse of Agony" },
  { rarity: "uncommon", mana: 4, name: "Curse of Decay" },
  { rarity: "uncommon", mana: 2, name: "Curse of Elements" },
  { rarity: "common", mana: 1, name: "Curse of Exhaustion" },
  { rarity: "uncommon", mana: 1, name: "Curse of Fragility" },
  { rarity: "rare", mana: 3, name: "Curse of Madness" },
  { rarity: "uncommon", mana: 2, name: "Curse of Shadows" },
  { rarity: "rare", mana: 3, name: "Curse of Vulnerability" },
  { rarity: "epic", mana: 3, name: "Curse of Weakness" },
  { rarity: "uncommon", mana: 2, name: "Dark Future" },
  { rarity: "rare", mana: 4, name: "Darkness Falls" },
  { rarity: "uncommon", mana: 1, name: "Dark Pact" },
  { rarity: "uncommon", mana: 1, name: "Dark Ritual" },
  { rarity: "epic", mana: 3, name: "Deep Darkness" },
  { rarity: "epic", mana: 9, name: "Disintegrate" },
  { rarity: "rare", mana: 2, name: "Drain Life" },
  { rarity: "common", mana: 2, name: "Electric Discharge" },
  { rarity: "uncommon", mana: 1, name: "Electricity Manual" },
  { rarity: "epic", mana: 5, name: "Electrocute" },
  { rarity: "rare", mana: 2, name: "Elemental Bolt" },
  { rarity: "common", mana: 1, name: "Elemental Ward" },
  { rarity: "common", mana: 1, name: "Emberstorm" },
  { rarity: "epic", mana: 7, name: "Endless Abyss" },
  { rarity: "epic", mana: 1, name: "Equivalent Exchange" },
  { rarity: "epic", mana: 2, name: "Evocation" },
  { rarity: "common", mana: 3, name: "Fireball" },
  { rarity: "common", mana: 0, name: "Fire Blast" },
  { rarity: "uncommon", mana: 4, name: "Firestorm" },
  { rarity: "rare", mana: 5, name: "Flamestrike" },
  { rarity: "common", mana: 2, name: "Flare" },
  { rarity: "epic", mana: 2, name: "Flash Freeze" },
  { rarity: "common", mana: 2, name: "Frostbolt" },
  { rarity: "uncommon", mana: 2, name: "Frost Nova" },
  { rarity: "uncommon", mana: 3, name: "Geyser" },
  { rarity: "rare", mana: 3, name: "Grimoire of Flames" },
  { rarity: "common", mana: 0, name: "Heat Wave" },
  { rarity: "uncommon", mana: 1, name: "Ice Barrier" },
  { rarity: "epic", mana: 7, name: "Ice Comet" },
  { rarity: "common", mana: 0, name: "Ice Lance" },
  { rarity: "common", mana: 1, name: "Icicle" },
  {
    rarity: "rare",
    mana: 2,
    name: "Icicle Barrage",
  },
  { rarity: "uncommon", mana: 0, name: "Icy Veins" },
  { rarity: "common", mana: 2, name: "Ignite" },
  { rarity: "rare", mana: 2, name: "Immolate" },
  { rarity: "uncommon", mana: 1, name: "Inner Combustion" },
  { rarity: "rare", mana: 1, name: "Invisibility" },
  { rarity: "rare", mana: 1, name: "Librarian" },
  { rarity: "uncommon", mana: 0, name: "Life Tap" },
  { rarity: "uncommon", mana: 2, name: "Living Flame" },
  { rarity: "common", mana: 0, name: "Malicious Eye" },
  { rarity: "epic", mana: 0, name: "Mana Gem" },
  { rarity: "common", mana: 1, name: "Mana Shield" },
  { rarity: "rare", mana: 2, name: "Mana Surge" },
  { rarity: "epic", mana: 2, name: "Mass Invisibility" },
  { rarity: "epic", mana: 7, name: "Meteorite" },
  { rarity: "mythic", mana: 9, name: "Meteor Shower" },
  { rarity: "uncommon", mana: 2, name: "Mirror Images" },
  { rarity: "common", mana: 1, name: "Necrotic Burst" },
  { rarity: "uncommon", mana: 2, name: "Nightmare" },
  { rarity: "rare", mana: 3, name: "Noxious Eruption" },
  { rarity: "uncommon", mana: 2, name: "Pestilence" },
  { rarity: "uncommon", mana: 2, name: "Prismatic Field" },
  { rarity: "epic", mana: 3, name: "Pyroblast" },
  { rarity: "common", mana: 0, name: "Rain" },
  { rarity: "rare", mana: 4, name: "Ray of Frost" },
  { rarity: "rare", mana: 1, name: "Recurring Nightmare" },
  { rarity: "rare", mana: 5, name: "Replenishment" },
  { rarity: "rare", mana: 3, name: "Scorching Ray" },
  { rarity: "uncommon", mana: 0, name: "Scroll Of Defense" },
  { rarity: "rare", mana: 0, name: "Scroll Of Intellect" },
  { rarity: "common", mana: 0, name: "Scroll Of Speed" },
  { rarity: "uncommon", mana: 3, name: "Searing Nova" },
  { rarity: "uncommon", mana: 1, name: "Searing Touch" },
  { rarity: "epic", mana: 3, name: "Shadow Binding" },
  { rarity: "common", mana: 2, name: "Shadow Bolt" },
  { rarity: "uncommon", mana: 3, name: "Shatter" },
  { rarity: "uncommon", mana: 0, name: "Shifting Scroll" },
  { rarity: "uncommon", mana: 4, name: "Shock Nova" },
  { rarity: "mythic", mana: 2, name: "Siphon Life" },
  { rarity: "rare", mana: 3, name: "Squall" },
  { rarity: "rare", mana: 2, name: "Superconductor" },
  { rarity: "epic", mana: 2, name: "The Encyclopedia" },
  { rarity: "rare", mana: 2, name: "Tome Of Intellect" },
  { rarity: "uncommon", mana: 2, name: "Transmission" },
  { rarity: "common", mana: 0, name: "Unstable Power" },
  { rarity: "mythic", mana: 2, name: "Vampiric Tutor" },
  { rarity: "uncommon", mana: 1, name: "Water Jet" },
  { rarity: "rare", mana: 3, name: "Winter Is Coming" },
  { rarity: "rare", mana: 4, name: "Winter Orb" },
  { rarity: "rare", mana: 3, name: "Winter's night Tale" },
  { rarity: "common", mana: 0, name: "Zap" },
];
const warriorCards = [
  { rarity: "epic", mana: 4, name: "Arsenal" },
  { rarity: "uncommon", mana: 0, name: "Barbed Wire" },
  { rarity: "uncommon", mana: 2, name: "Barricade" },
  { rarity: "rare", mana: 1, name: "Battle Plan" },
  { rarity: "rare", mana: 3, name: "Battle Shout" },
  { rarity: "common", mana: 3, name: "Blade Storm" },
  { rarity: "epic", mana: 2, name: "Bleed Out" },
  { rarity: "rare", mana: 3, name: "Bloodbath" },
  { rarity: "rare", mana: 1, name: "Blood Feeding" },
  { rarity: "uncommon", mana: 1, name: "Blood For Blood" },
  { rarity: "rare", mana: 0, name: "Bloodrage" },
  { rarity: "rare", mana: 3, name: "Bludgeon" },
  { rarity: "rare", mana: 1, name: "Bluff" },
  { rarity: "epic", mana: 5, name: "Bouncing Shield" },
  { rarity: "uncommon", mana: 0, name: "Burning Blood" },
  { rarity: "rare", mana: 3, name: "Butchering" },
  { rarity: "rare", mana: 2, name: "Carnage" },
  { rarity: "mythic", mana: 4, name: "Challenging Shout" },
  { rarity: "uncommon", mana: 1, name: "Change Weapon" },
  { rarity: "common", mana: 2, name: "Charge" },
  { rarity: "mythic", mana: 9, name: "Citadel" },
  { rarity: "uncommon", mana: 2, name: "Cleave" },
  { rarity: "uncommon", mana: 3, name: "Coat of Arms" },
  { rarity: "rare", mana: 3, name: "Colossal Blow" },
  { rarity: "common", mana: 1, name: "Defend" },
  { rarity: "epic", mana: 3, name: "Demolishing Blow" },
  { rarity: "epic", mana: 3, name: "Demoralizing Shout" },
  { rarity: "mythic", mana: 2, name: "Devastate" },
  { rarity: "rare", mana: 2, name: "Do It Yourself" },
  { rarity: "epic", mana: 1, name: "Enrage" },
  { rarity: "rare", mana: 4, name: "Entrench" },
  { rarity: "rare", mana: 3, name: "Exploit Openings" },
  { rarity: "common", mana: 1, name: "Fast Strike" },
  { rarity: "rare", mana: 1, name: "First Aid" },
  { rarity: "uncommon", mana: 2, name: "Flanking Strike" },
  { rarity: "rare", mana: 3, name: "Furious Slash" },
  { rarity: "epic", mana: 2, name: "Garden Of Thorns" },
  { rarity: "epic", mana: 1, name: "Grinding Wheel" },
  { rarity: "rare", mana: 3, name: "Ground Slam" },
  { rarity: "uncommon", mana: 2, name: "Guard" },
  { rarity: "common", mana: 2, name: "Hamstring" },
  { rarity: "common", mana: 1, name: "Headbutt" },
  { rarity: "common", mana: 3, name: "Heavy Strike" },
  { rarity: "common", mana: 0, name: "Helping Hand" },
  { rarity: "uncommon", mana: 2, name: "Impale" },
  { rarity: "epic", mana: 3, name: "Infuriate" },
  { rarity: "common", mana: 0, name: "Intercept" },
  { rarity: "common", mana: 0, name: "Intimidate" },
  {
    rarity: "rare",
    mana: 2,
    name: "Invigorating Blow",
  },
  { rarity: "epic", mana: 3, name: "Last Stand" },
  { rarity: "uncommon", mana: 3, name: "Leap Slam" },
  { rarity: "uncommon", mana: 3, name: "Maim" },
  { rarity: "rare", mana: 4, name: "Mortal Strike" },
  { rarity: "rare", mana: 2, name: "Overpower" },
  { rarity: "uncommon", mana: 1, name: "Piercing Howl" },
  { rarity: "common", mana: 1, name: "Pommel" },
  { rarity: "common", mana: 2, name: "Precise Strike" },
  { rarity: "epic", mana: 2, name: "Provoke" },
  { rarity: "rare", mana: 2, name: "Pulverize" },
  { rarity: "rare", mana: 2, name: "Pummel" },
  { rarity: "common", mana: 0, name: "Punch" },
  { rarity: "epic", mana: 2, name: "Push Forward" },
  { rarity: "uncommon", mana: 2, name: "Rampage" },
  { rarity: "uncommon", mana: 3, name: "Reckless Charge" },
  { rarity: "epic", mana: 3, name: "Reinforced Steel" },
  { rarity: "uncommon", mana: 2, name: "Rend" },
  { rarity: "common", mana: 1, name: "Repair Armor" },
  { rarity: "rare", mana: 1, name: "Repetition Training" },
  { rarity: "rare", mana: 4, name: "Safeguard" },
  { rarity: "mythic", mana: 2, name: "Second Wind" },
  { rarity: "rare", mana: 4, name: "Sever Artery" },
  { rarity: "uncommon", mana: 1, name: "Shake It Off" },
  { rarity: "uncommon", mana: 1, name: "Sharing Is Caring" },
  { rarity: "uncommon", mana: 1, name: "Sharpen" },
  { rarity: "common", mana: 2, name: "Shield Bash" },
  { rarity: "rare", mana: 3, name: "Shield Breaker" },
  { rarity: "uncommon", mana: 2, name: "Shield Charge" },
  { rarity: "rare", mana: 3, name: "Shield Slam" },
  { rarity: "uncommon", mana: 2, name: "Shield Throw" },
  { rarity: "epic", mana: 5, name: "Shield Wall" },
  { rarity: "epic", mana: 3, name: "Siege Breaker" },
  { rarity: "uncommon", mana: 5, name: "Skullsplitter" },
  { rarity: "rare", mana: 2, name: "Spiked Ball" },
  { rarity: "uncommon", mana: 2, name: "Spiked Shield" },
  { rarity: "common", mana: 2, name: "Steelskin" },
  { rarity: "rare", mana: 3, name: "Stockade" },
  { rarity: "uncommon", mana: 3, name: "Sunder Armor" },
  { rarity: "common", mana: 2, name: "Sweeping Strike" },
  { rarity: "rare", mana: 3, name: "Thousand Needles" },
  { rarity: "rare", mana: 3, name: "Throw Bolas" },
  { rarity: "mythic", mana: 4, name: "Titan Fall" },
  { rarity: "rare", mana: 1, name: "Torment of Thorns" },
  { rarity: "uncommon", mana: 0, name: "Transfusion" },
  { rarity: "common", mana: 0, name: "Warpaint" },
  { rarity: "epic", mana: 6, name: "Whirlwind" },
  { rarity: "rare", mana: 3, name: "Wrecking Ball" },
];
const scoutCards = [
  { rarity: "rare", mana: 3, name: "Acrobatic Strike" },
  { rarity: "rare", mana: 0, name: "Adrenaline" },
  { rarity: "common", mana: 2, name: "Aimed Shot" },
  { rarity: "epic", mana: 1, name: "Ambidextrous" },
  { rarity: "uncommon", mana: 3, name: "Ambush" },
  { rarity: "uncommon", mana: 1, name: "Ammunitions" },
  { rarity: "common", mana: 2, name: "Annoying Whistle" },
  { rarity: "rare", mana: 3, name: "Backstab" },
  { rarity: "epic", mana: 3, name: "Ballad of Conquest" },
  { rarity: "rare", mana: 3, name: "Ballad of Evasion" },
  { rarity: "rare", mana: 2, name: "Bane" },
  { rarity: "mythic", mana: 5, name: "Barrage" },
  { rarity: "uncommon", mana: 2, name: "Blade Dance" },
  { rarity: "uncommon", mana: 3, name: "Blade Flurry" },
  { rarity: "common", mana: 1, name: "Blur" },
  { rarity: "common", mana: 3, name: "Burning Shot" },
  { rarity: "uncommon", mana: 1, name: "Caltrops" },
  { rarity: "uncommon", mana: 1, name: "Camouflage" },
  { rarity: "uncommon", mana: 2, name: "Captivating Voice" },
  { rarity: "uncommon", mana: 1, name: "Chant of Accuracy" },
  { rarity: "common", mana: 1, name: "Chant of Initiative" },
  { rarity: "epic", mana: 4, name: "Corrupted Blade" },
  { rarity: "epic", mana: 3, name: "Debilitate" },
  { rarity: "uncommon", mana: 0, name: "Deflect" },
  { rarity: "uncommon", mana: 1, name: "Detection" },
  { rarity: "uncommon", mana: 2, name: "Disengage" },
  { rarity: "uncommon", mana: 2, name: "Double Strike" },
  { rarity: "common", mana: 2, name: "Dual Strike" },
  { rarity: "common", mana: 3, name: "Energizing Serenade" },
  { rarity: "rare", mana: 5, name: "Eternal Lullaby" },
  { rarity: "mythic", mana: 7, name: "Eviscerate" },
  { rarity: "uncommon", mana: 4, name: "Explosive Shot" },
  { rarity: "uncommon", mana: 3, name: "Expose Armor" },
  { rarity: "rare", mana: 3, name: "Fan of Knives" },
  { rarity: "rare", mana: 5, name: "Far Shot" },
  { rarity: "common", mana: 0, name: "Feint" },
  { rarity: "rare", mana: 1, name: "Find Weakness" },
  { rarity: "epic", mana: 3, name: "Healing Serenade" },
  { rarity: "rare", mana: 0, name: "Hidden Weapon" },
  { rarity: "common", mana: 2, name: "Hit and Run" },
  { rarity: "uncommon", mana: 1, name: "Hunter's Mark" },
  { rarity: "common", mana: 2, name: "Ice Shot" },
  { rarity: "mythic", mana: 8, name: "Last Requiem" },
  { rarity: "mythic", mana: 2, name: "Last Reward" },
  { rarity: "rare", mana: 4, name: "Lethal Shot" },
  { rarity: "uncommon", mana: 2, name: "Multishot" },
  { rarity: "rare", mana: 1, name: "Music Sheet" },
  { rarity: "epic", mana: 3, name: "Neurotoxin" },
  { rarity: "epic", mana: 2, name: "Neverending Story" },
  { rarity: "uncommon", mana: 1, name: "Ode of War" },
  { rarity: "rare", mana: 2, name: "Parry" },
  { rarity: "uncommon", mana: 2, name: "Plague Shot" },
  { rarity: "epic", mana: 2, name: "Poison Catalyst" },
  { rarity: "common", mana: 0, name: "Poison Dart" },
  { rarity: "rare", mana: 2, name: "Poisoned Daggers" },
  { rarity: "epic", mana: 3, name: "Poison Flask" },
  { rarity: "rare", mana: 1, name: "Poisonous Blood" },
  { rarity: "common", mana: 2, name: "Poisonous Shot" },
  { rarity: "rare", mana: 3, name: "Poison Spray" },
  { rarity: "rare", mana: 2, name: "Puncture" },
  { rarity: "common", mana: 1, name: "Quick Shot" },
  { rarity: "epic", mana: 6, name: "Rain of Arrows" },
  { rarity: "common", mana: 3, name: "Rapid Fire" },
  { rarity: "rare", mana: 3, name: "Reverberant Verse" },
  { rarity: "uncommon", mana: 2, name: "Ricochet" },
  { rarity: "common", mana: 2, name: "Rupture" },
  { rarity: "uncommon", mana: 4, name: "Sarcastic Sonnet" },
  { rarity: "uncommon", mana: 2, name: "Saw Blade" },
  { rarity: "common", mana: 1, name: "Sawtooth Knife" },
  { rarity: "uncommon", mana: 0, name: "Scavenge" },
  { rarity: "uncommon", mana: 1, name: "Setup" },
  { rarity: "rare", mana: 1, name: "Shadowstep" },
  { rarity: "rare", mana: 2, name: "Sharpening Knife" },
  { rarity: "common", mana: 0, name: "Shiv" },
  { rarity: "uncommon", mana: 2, name: "Shrapnel Shot" },
  { rarity: "common", mana: 1, name: "Slice" },
  { rarity: "epic", mana: 2, name: "Smoke Bomb" },
  { rarity: "common", mana: 0, name: "Sneak Peek" },
  { rarity: "rare", mana: 2, name: "Sneaky Strike" },
  { rarity: "epic", mana: 2, name: "Sniper Shot" },
  { rarity: "common", mana: 1, name: "Song of Celerity" },
  { rarity: "uncommon", mana: 2, name: "Song of Quickness" },
  { rarity: "common", mana: 0, name: "Sprint" },
  { rarity: "common", mana: 1, name: "Stoneskin" },
  { rarity: "uncommon", mana: 2, name: "Sweet Melody" },
  { rarity: "rare", mana: 5, name: "Tedious Poem" },
  { rarity: "common", mana: 0, name: "Toxic Rain" },
  { rarity: "rare", mana: 3, name: "Toxic Strike" },
  { rarity: "common", mana: 0, name: "Trace" },
  { rarity: "uncommon", mana: 1, name: "Tune Up" },
  { rarity: "uncommon", mana: 1, name: "Uproot" },
  { rarity: "rare", mana: 0, name: "Vanish" },
  { rarity: "uncommon", mana: 2, name: "Vexing Crescendo" },
  { rarity: "common", mana: 1, name: "Vigilance" },
  { rarity: "common", mana: 1, name: "Viper Strike" },
  { rarity: "uncommon", mana: 3, name: "Vitalizing Serenade" },
  { rarity: "rare", mana: 4, name: "Volley" },
  { rarity: "epic", mana: 4, name: "Weapon Cache" },
  { rarity: "uncommon", mana: 1, name: "Whispering Lies" },
  { rarity: "rare", mana: 1, name: "Wicked Craftsman" },
];
const healerCards = [
  { rarity: "uncommon", mana: 2, name: "Anthem of Hope" },
  { rarity: "common", mana: 0, name: "Bad Augury" },
  { rarity: "epic", mana: 2, name: "Baptism" },
  { rarity: "common", mana: 1, name: "Barrier" },
  { rarity: "uncommon", mana: 2, name: "Benediction" },
  { rarity: "uncommon", mana: 2, name: "Binding Heal" },
  { rarity: "mythic", mana: 2, name: "Black Hole" },
  { rarity: "uncommon", mana: 1, name: "Black Karma" },
  { rarity: "uncommon", mana: 2, name: "Bulk Heal" },
  { rarity: "epic", mana: 7, name: "Celestial Brillance" },
  { rarity: "rare", mana: 3, name: "Chain Heal" },
  { rarity: "epic", mana: 5, name: "Circle of Healing" },
  { rarity: "uncommon", mana: 2, name: "Clairvoyance" },
  { rarity: "common", mana: 0, name: "Clarity" },
  { rarity: "rare", mana: 3, name: "Condemnation" },
  { rarity: "mythic", mana: 5, name: "Crescent Light" },
  { rarity: "rare", mana: 2, name: "Curative Therapy" },
  { rarity: "uncommon", mana: 3, name: "Dark Outbreak" },
  { rarity: "common", mana: 0, name: "Dawnlight" },
  { rarity: "epic", mana: 5, name: "Death's Reach" },
  { rarity: "uncommon", mana: 1, name: "Delay Response" },
  { rarity: "mythic", mana: 2, name: "Demonic Tutor" },
  { rarity: "epic", mana: 4, name: "Desperate Prayer" },
  { rarity: "common", mana: 0, name: "Detoxify" },
  { rarity: "uncommon", mana: 1, name: "Dilute" },
  { rarity: "uncommon", mana: 1, name: "Dispel Magic" },
  { rarity: "rare", mana: 5, name: "Divine Insight" },
  { rarity: "rare", mana: 3, name: "Divine Ire" },
  { rarity: "rare", mana: 3, name: "Divine Power" },
  { rarity: "epic", mana: 3, name: "Enervate" },
  { rarity: "uncommon", mana: 1, name: "Expected Prophecy" },
  { rarity: "common", mana: 1, name: "Fade" },
  { rarity: "uncommon", mana: 0, name: "Fanaticism" },
  { rarity: "common", mana: 1, name: "Flash" },
  { rarity: "common", mana: 1, name: "Flash Heal" },
  { rarity: "common", mana: 0, name: "Foresight" },
  { rarity: "uncommon", mana: 1, name: "Fortune Telling" },
  { rarity: "rare", mana: 4, name: "Greater Heal" },
  { rarity: "mythic", mana: 5, name: "Guardian Angel" },
  { rarity: "uncommon", mana: 2, name: "Hallucination" },
  { rarity: "common", mana: 2, name: "Heal" },
  { rarity: "common", mana: 0, name: "Healing Rain" },
  { rarity: "mythic", mana: 8, name: "Heavenly Blessing" },
  { rarity: "epic", mana: 4, name: "Holy Aegis" },
  { rarity: "rare", mana: 2, name: "Holy Blast" },
  { rarity: "rare", mana: 3, name: "Holy Fire" },
  { rarity: "uncommon", mana: 2, name: "Holy Nova" },
  { rarity: "uncommon", mana: 3, name: "Holy Ripple" },
  {
    rarity: "common",
    mana: 2,
    name: "Holy Smite",
  },
  { rarity: "uncommon", mana: 4, name: "Holy Storm" },
  { rarity: "common", mana: 1, name: "Infuse Courage" },
  { rarity: "common", mana: 0, name: "Inner Fire" },
  { rarity: "rare", mana: 1, name: "Innervate" },
  { rarity: "epic", mana: 3, name: "Mass Dispel" },
  { rarity: "epic", mana: 0, name: "Meditate" },
  { rarity: "common", mana: 2, name: "Mental Shake" },
  { rarity: "epic", mana: 7, name: "Mesmeric Mirage" },
  { rarity: "common", mana: 1, name: "Mind Blast" },
  { rarity: "uncommon", mana: 3, name: "Mind Twist" },
  { rarity: "uncommon", mana: 2, name: "Mind Visions" },
  { rarity: "rare", mana: 1, name: "Omen of Peril" },
  { rarity: "rare", mana: 4, name: "Pain Suppression" },
  { rarity: "rare", mana: 3, name: "Panacea" },
  { rarity: "rare", mana: 5, name: "Pandemonium" },
  { rarity: "uncommon", mana: 3, name: "Penance" },
  { rarity: "uncommon", mana: 2, name: "Prayer of Healing" },
  { rarity: "uncommon", mana: 2, name: "Prayer of Protection" },
  { rarity: "rare", mana: 1, name: "Prescription" },
  { rarity: "rare", mana: 3, name: "Profane" },
  { rarity: "rare", mana: 3, name: "Protect from Evil" },
  { rarity: "rare", mana: 3, name: "Pulsing Heal" },
  { rarity: "epic", mana: 3, name: "Purging Ray" },
  { rarity: "rare", mana: 5, name: "Radiant Assault" },
  { rarity: "common", mana: 2, name: "Ray of Hope" },
  { rarity: "rare", mana: 2, name: "Renew" },
  { rarity: "rare", mana: 3, name: "Ruin Bolt" },
  { rarity: "common", mana: 2, name: "Sacred Bolt" },
  { rarity: "epic", mana: 6, name: "Sacred Ceremony" },
  { rarity: "epic", mana: 3, name: "Sanctification" },
  { rarity: "epic", mana: 5, name: "Sanctuary" },
  { rarity: "rare", mana: 1, name: "Save It For Later" },
  { rarity: "common", mana: 0, name: "Scry" },
  { rarity: "common", mana: 1, name: "Shadow Mend" },
  { rarity: "common", mana: 2, name: "Shield of Warding" },
  { rarity: "uncommon", mana: 3, name: "Shining Force" },
  { rarity: "rare", mana: 3, name: "Spark of Life" },
  { rarity: "rare", mana: 2, name: "Spectral Missiles" },
  { rarity: "uncommon", mana: 1, name: "Sunbeam" },
  { rarity: "epic", mana: 2, name: "Tabula Rasa" },
  { rarity: "rare", mana: 3, name: "Temporal Chains" },
  { rarity: "rare", mana: 4, name: "Terrorize" },
  { rarity: "uncommon", mana: 4, name: "Unholy Storm" },
  { rarity: "rare", mana: 1, name: "Vampiric Touch" },
  { rarity: "uncommon", mana: 2, name: "Vile Gas" },
  { rarity: "common", mana: 2, name: "Vile Lance" },
  { rarity: "uncommon", mana: 2, name: "Vitalize" },
  { rarity: "rare", mana: 3, name: "Yin Yang Bolt" },
];
const enchantmentCards = [
  { rarity: "epic", mana: 1, name: "Arcane Conduit" },
  { rarity: "rare", mana: 1, name: "Black Talons" },
  { rarity: "rare", mana: 1, name: "Chilling Gaze" },
  { rarity: "rare", mana: 0, name: "Circuit Overload" },
  { rarity: "epic", mana: 1, name: "Command and Conquer" },
  { rarity: "rare", mana: 0, name: "Cursemancy" },
  { rarity: "epic", mana: 1, name: "Deadly Strikes" },
  { rarity: "epic", mana: 1, name: "Death's Embrace" },
  { rarity: "rare", mana: 1, name: "Defensive Strategy" },
  { rarity: "rare", mana: 1, name: "Divine Retribution" },
  { rarity: "epic", mana: 0, name: "Double Bubble" },
  { rarity: "epic", mana: 0, name: "Double Shot" },
  { rarity: "epic", mana: 0, name: "Dual Wield" },
  { rarity: "rare", mana: 0, name: "Electric Weapons" },
  { rarity: "rare", mana: 0, name: "Elemental Proliferation" },
  { rarity: "rare", mana: 1, name: "Elven Agility" },
  { rarity: "rare", mana: 1, name: "Enchant Weapons" },
  { rarity: "epic", mana: 0, name: "Encore" },
  { rarity: "epic", mana: 1, name: "Ethereal Weapons" },
  { rarity: "epic", mana: 1, name: "Fated Future" },
  { rarity: "rare", mana: 0, name: "Fiery Weapons" },
  { rarity: "rare", mana: 1, name: "Fireproof" },
  { rarity: "rare", mana: 0, name: "Focus Heal" },
  { rarity: "rare", mana: 0, name: "Follow-up" },
  { rarity: "rare", mana: 0, name: "Frost Weapons" },
  { rarity: "epic", mana: 1, name: "Fusion Laser" },
  { rarity: "rare", mana: 1, name: "Grudge" },
  { rarity: "epic", mana: 1, name: "Hawkeye" },
  { rarity: "rare", mana: 0, name: "Heavy Metal" },
  { rarity: "rare", mana: 0, name: "Hellflame" },
  { rarity: "epic", mana: 0, name: "Hidden Hand" },
  { rarity: "epic", mana: 1, name: "Holy Crusader" },
  { rarity: "epic", mana: 1, name: "Holy Symbol" },
  { rarity: "epic", mana: 1, name: "Infestation" },
  { rarity: "epic", mana: 1, name: "Last Guardian" },
  { rarity: "rare", mana: 1, name: "Love Enhancer" },
  { rarity: "rare", mana: 0, name: "Maneuver" },
  { rarity: "rare", mana: 1, name: "Melodic Rhythm" },
  { rarity: "rare", mana: 0, name: "Night Terror" },
  { rarity: "rare", mana: 1, name: "Onslaught" },
  { rarity: "epic", mana: 1, name: "Phoenix" },
  { rarity: "rare", mana: 1, name: "Praise the Sun" },
  { rarity: "rare", mana: 1, name: "Reactive Laser" },
  { rarity: "epic", mana: 1, name: "Red Storm" },
  { rarity: "epic", mana: 1, name: "Riposte" },
  { rarity: "epic", mana: 1, name: "Serrated Weapons" },
  { rarity: "rare", mana: 1, name: "Skillful" },
  { rarity: "epic", mana: 1, name: "Solar Flare" },
  { rarity: "rare", mana: 0, name: "Soul Harvest" },
  { rarity: "epic", mana: 0, name: "Spell Echo" },
  { rarity: "epic", mana: 1, name: "Stampede" },
  { rarity: "rare", mana: 1, name: "Steel Forge" },
  { rarity: "rare", mana: 1, name: "Subterfuge" },
  { rarity: "rare", mana: 0, name: "Target Shooting" },
  { rarity: "epic", mana: 1, name: "Tesla Coil" },
  { rarity: "epic", mana: 1, name: "The Chosen One" },
  { rarity: "epic", mana: 1, name: "Thunderclap" },
  { rarity: "epic", mana: 0, name: "Transcribe" },
  { rarity: "rare", mana: 1, name: "Unforgiving Nature" },
  { rarity: "rare", mana: 1, name: "Unwavering Faith" },
  { rarity: "epic", mana: 1, name: "Vaccine" },
  { rarity: "epic", mana: 1, name: "Valiant Defender" },
  { rarity: "rare", mana: 0, name: "Wild Hunt" },
  { rarity: "rare", mana: 1, name: "Wolf Guard" },
  { rarity: "epic", mana: 1, name: "World in Flames" },
  { rarity: "rare", mana: 1, name: "Yang Ritual" },
  { rarity: "rare", mana: 1, name: "Yin Ritual" },
];
const boonCards = [
  { name: "Arena Champion", rarity: "rare", mana: 0 },
  { name: "Catharsis", rarity: "mythic", mana: 0 },
  { name: "Child of the Storm", rarity: "rare", mana: 0 },
  { name: "Custodian", rarity: "uncommon", mana: 0 },
  { name: "Dark Miasma", rarity: "epic", mana: 0 },
  { name: "Enlightened", rarity: "epic", mana: 0 },
  { name: "Friendly Tadpole", rarity: "epic", mana: 0 },
  { name: "Heat Surge", rarity: "rare", mana: 0 },
  { name: "Honorable", rarity: "rare", mana: 0 },
  { name: "Merciful", rarity: "rare", mana: 0 },
  { name: "Merciless", rarity: "rare", mana: 0 },
  { name: "Owl Blessing", rarity: "rare", mana: 0 },
  { name: "Take Cover", rarity: "uncommon", mana: 0 },
  { name: "Trustworthy", rarity: "rare", mana: 0 },
  { name: "Well Fed", rarity: "rare", mana: 0 },
];

export const cardClasses = [
  "healer",
  "warrior",
  "scout",
  "mage",
  "enchantment",
  "boon",
];

export const cards = {
  healer: healerCards,
  warrior: warriorCards,
  scout: scoutCards,
  mage: mageCards,
  enchantment: enchantmentCards,
  boon: boonCards,
  colors: {
    healer: "#897d6d",
    warrior: "#911d1d",
    scout: "#2b5a28",
    mage: "#2b5689",
    enchantment: "#af8449",
    boon: "#23b4b8",
  },
  all: function () {
    return [
      ...healerCards,
      ...warriorCards,
      ...scoutCards,
      ...mageCards,
      ...enchantmentCards,
      ...boonCards,
    ];
  },
};

export const menuItems = {
  width: 215,
  height: 75,
  perkClasses: ["general", "phys", "ele", "mys"],
};

export const perks = {
  offsetX: 76,
  offsetY: 77,
  columnW: 114.375,
  rowH: 129,
  circleR: 39.5,
  generalPerks: {
    columns: [
      {
        name: "health",
        normal: [
          { id: 0, desc: "Max  HP +4" },
          { id: 1, desc: "Max  HP +4" },
          { id: 2, desc: "Max  HP +4" },
          { id: 3, desc: "Max  HP +4" },
          { id: 4, desc: "Max  HP +4" },
          { id: 5, desc: "Max  HP +4" },
        ],
        golden: [{ id: 6, desc: "Max HP +12" }],
        special: [],
      },
      {
        name: "resistance",
        normal: [
          { id: 0, desc: "All resistances +2%" },
          { id: 1, desc: "All resistances +2%" },
          { id: 2, desc: "All resistances +2%" },
          { id: 3, desc: "All resistances +2%" },
          { id: 4, desc: "All resistances +2%" },
        ],
        golden: [{ id: 5, desc: "All resistances +6%" }],
        special: [],
      },
      {
        name: "currency",
        normal: [
          { id: 0, desc: "Initial gold +75" },
          { id: 1, desc: "Initial gold +75" },
          { id: 2, desc: "Initial gold +75" },
          { id: 3, desc: "Initial gold +75" },
          { id: 4, desc: "Initial gold +75" },
          { id: 5, desc: "Initial gold +75" },
        ],
        golden: [{ id: 6, desc: "Initial gold +225" }],
        special: [],
      },
      {
        name: "shards",
        normal: [
          { id: 0, desc: "Initial shards +75" },
          { id: 1, desc: "Initial shards +75" },
          { id: 2, desc: "Initial shards +75" },
          { id: 3, desc: "Initial shards +75" },
          { id: 4, desc: "Initial shards +75" },
        ],
        golden: [{ id: 5, desc: "Initial shards +225" }],
        special: [],
      },
      {
        name: "fast",
        normal: [],
        golden: [{ id: 4, desc: "Charges that you apply +1" }],
        special: [],
      },
      {
        name: "speed",
        normal: [{ id: 1, desc: "Speed +1" }],
        golden: [
          { id: 3, desc: "Speed +1" },
          { id: 5, desc: "Speed +1" },
        ],
        special: [],
      },
      {
        name: "slow",
        normal: [],
        golden: [{ id: 4, desc: "Chargest that you apply +1" }],
        special: [],
      },
      {
        name: "energy",
        normal: [{ id: 2, desc: "Initial energy +1" }],
        golden: [{ id: 4, desc: "Initial energy +1" }],
        special: [
          {
            id: 6,
            desc: "Choose one of the following perks",
            opts: [
              {
                desc: "When this hero plays a card that costs 6 Energy or more, refund 1 Energy",
              },
              {
                desc: "On round 2, this hero gains 1 Energy at the start of the turn",
              },
              {
                desc: "On round 4, this hero gains 2 Energy at the start of the turn",
              },
            ],
          },
        ],
      },
      {
        name: "sight",
        normal: [{ id: 0, desc: "Chargest that you apply +1" }],
        golden: [],
        special: [
          {
            id: 3,
            desc: "Choose one of the following perks",
            opts: [
              { desc: "Charges that you apply +1" },
              {
                desc: "Sight on enemies also removes stealth when applied and cannot be dispelled unless specified",
              },
              {
                desc: "Charges that you apply +3. Sight on enemise cannot be prevented by Buffer or immunity to Sight, but loses all charges at the end of the turn",
              },
            ],
          },
        ],
      },
      {
        name: "mark",
        normal: [{ id: 4, desc: "Chargest that you apply +1" }],
        golden: [],
        special: [
          {
            id: 6,
            desc: "Choose one of the following perks",
            opts: [
              { desc: "This hero is immune to Mark" },
              {
                desc: "Mark on enemies does not lose charges when preventing Stealth and at the end of the turn.",
              },
              {
                desc: "Mark on enemies also reduces Slashing resistance by 0.3% per charge",
              },
            ],
          },
        ],
      },
      {
        name: "buffer",
        normal: [{ id: 2, desc: "Chargest that you apply +1" }],
        golden: [{ id: 5, desc: "Chargest that you apply +1" }],
        special: [],
      },
      {
        name: "stealth",
        normal: [{ id: 2, desc: "Chargest that you apply +1" }],
        golden: [],
        special: [
          {
            id: 6,
            desc: "Choose one of the following perks",
            opts: [
              {
                desc: "Stealth on heroes increases damage and healing done by 25% per charge",
              },
              {
                desc: "Stealth on this hero does not lose charges at the start of the turn",
              },
              {
                desc: "Stealth on heroes also increases all resistances by 5% per charge",
              },
            ],
          },
        ],
      },
    ],
  },

  physPerks: {
    columns: [
      {
        name: "fury",
        normal: [{ id: 2, desc: "Chargest that you apply +1" }],
        golden: [],
        special: [
          {
            id: 6,
            desc: "Choose one of the following perks",
            opts: [
              { desc: "Charges that you apply +1" },
              {
                desc: "Fury on this hero instead increases damage by 1% per charge but no longer applies Bleed at the end of the turn",
              },
              {
                desc: "Fury on this hero instead increases damage by 5% per charge. Bleed on this hero deals 50% more damage and cannot be prevented by Buffer or immunity to Bleed",
              },
            ],
          },
        ],
      },
      {
        name: "bleed",
        normal: [{ id: 1, desc: "Chargest that you apply +1" }],
        golden: [{ id: 3, desc: "Chargest that you apply +1" }],
        special: [
          {
            id: 5,
            desc: "Choose one of the following perks",
            opts: [
              { desc: "Charges that you apply +1" },
              {
                desc: "Bleed on this hero instead deals its damage at the end of the turn but cannot be dispelled unless specified. Fury maximum charges on this hero are 25",
              },
              {
                desc: "Charges that you apply +2. Bleed on enemies instead deals damage at the end of the turn but cannot be prevented by Buffer or immunity to Bleed",
              },
            ],
          },
        ],
      },
      {
        name: "slashing",
        normal: [
          { id: 0, desc: "Slashing +1 damage" },
          { id: 2, desc: "Slashing +1 damage" },
        ],
        golden: [{ id: 4, desc: "Slashing +2 damage" }],
        special: [],
      },
      {
        name: "sharp",
        normal: [{ id: 2, desc: "Chargest that you apply +1" }],
        golden: [],
        special: [
          {
            id: 6,
            desc: "Choose one of the following perks",
            opts: [
              {
                desc: "Sharp on this hero instead increases Slashing damage by 1.5 per charge but no longer increases Piercing damage",
              },
              {
                desc: "Sharp on this hero instead increases Piercing damage by 1.5 per charge but no longer increases Slashing damage",
              },
              {
                desc: "Sharp on heroes does not lose charges at the end of the turn and cannot be purged unless specified",
              },
              {
                desc: "Sharp on heroes also increases the Shadow damage by 1 per charge",
              },
            ],
          },
        ],
      },
      {
        name: "poison",
        normal: [{ id: 1, desc: "Chargest that you apply +1" }],
        golden: [{ id: 3, desc: "Chargest that you apply +1" }],
        special: [
          {
            id: 5,
            desc: "Choose one of the following perks",
            opts: [
              { desc: "Charges that you apply +1" },
              {
                desc: "Poison on enemies also reduces Shadow resistance by 0.3% per charge",
              },
              {
                desc: "Poison on enemies deals 50% more damage but loses all charges at the end of the turn",
              },
            ],
          },
        ],
      },
      {
        name: "piercing",
        normal: [
          { id: 0, desc: "Piercing +1 damage" },
          { id: 2, desc: "Piercing +1 damage" },
        ],
        golden: [{ id: 4, desc: "Piercing +2 damage" }],
        special: [],
      },
      {
        name: "thorns",
        normal: [{ id: 2, desc: "Chargest that you apply +1" }],
        golden: [],
        special: [
          {
            id: 6,
            desc: "Choose one of the following perks",
            opts: [
              { desc: "Thorns on heroes do not lose charges when hit" },
              { desc: "Thorns on this hero instead deal Holy damage" },
              {
                desc: "Thorns on this hero apply 50% of its charges as Poison to the attacker, instead of doing damage",
              },
            ],
          },
        ],
      },
      {
        name: "crack",
        normal: [{ id: 1, desc: "Chargest that you apply +1" }],
        golden: [{ id: 3, desc: "Chargest that you apply +1" }],
        special: [
          {
            id: 5,
            desc: "Choose one of the following perks",
            opts: [
              { desc: "Charges that you apply +1" },
              {
                desc: "Crack on enemies also reduces the Block chages gained by 0.5 per charge",
              },
              {
                desc: "Crack on enemies also applies 1 Vulnerable per 14 charges at the end of the turn",
              },
            ],
          },
        ],
      },
      {
        name: "blunt",
        normal: [
          { id: 0, desc: "Blunt +1 damage" },
          { id: 2, desc: "Blunt +1 damage" },
        ],
        golden: [{ id: 4, desc: "Blunt +2 damage" }],
        special: [],
      },
      {
        name: "vulnerable/fortify",
        normal: [{ id: 4, sub: "fortify", desc: "Chargest that you apply +1" }],
        golden: [],
        special: [
          {
            id: 3,
            desc: "Choose one of the following perks",
            sub: "vulnerable",
            opts: [
              { desc: "Charges that you apply +1" },
              {
                desc: "Maximum charges of Vulnerable on enemies increased by 1. Charges are instead reduced by 1 at the end of the turn",
              },
              {
                desc: "Vulnerable on enemies only reduces Slashing, Piercing and Blunt resistances, but the reduction is increased to 8% per charge.",
              },
            ],
          },
          {
            id: 6,
            desc: "Choose one of the following perks",
            sub: "fortify",
            opts: [
              {
                desc: "Fortify on this hero can stack and increases Blunt and Fire damage by 1 per charge. Maximum charges are 10",
              },
              {
                desc: "This hero gains 1 Fortify on their first turn. Fortify on this hero cannot be purged unless specified",
              },
              {
                desc: "Fortify on heroes also grants 5 Block per charge at the end of the round",
              },
            ],
          },
        ],
      },
      {
        name: "block",
        normal: [
          { id: 0, desc: "Chargest that you apply +1" },
          { id: 1, desc: "Chargest that you apply +1" },
          { id: 3, desc: "Chargest that you apply +1" },
          { id: 4, desc: "Chargest that you apply +1" },
        ],
        golden: [
          { id: 2, desc: "Chargest that you apply +2" },
          { id: 5, desc: "Chargest that you apply +3" },
        ],
        special: [],
      },
      {
        name: "reinforce/taunt",
        normal: [{ id: 5, sub: "taunt", desc: "Chargest that you apply +1" }],
        golden: [
          {
            id: 2,
            desc: "This hero gains 1 Reinforce at the start of the combat. Reinforce on this hero cannot be purget unless specified.",
            sub: "reinforce",
          },
        ],
        special: [
          {
            id: 4,
            desc: "Choose one of the following perks",
            sub: "reinforce",
            opts: [
              { desc: "Charges that you apply +1" },
              {
                desc: "Reinforce on heroes instead increases Slashing, Piercing and Blunt resistances by 35%",
              },
              {
                desc: "Reinforce on this hero can stac and instead increases the Slashing, Piercing and Blunt resistances by 5% per charge. Maximum charges are 10",
              },
            ],
          },
          {
            id: 6,
            desc: "Choose one of the following perks",
            sub: "taunt",
            opts: [
              {
                desc: "Taunt on this hero also increases Slashing, Piercing and Blunt resistances by 10% per charge",
              },
              {
                desc: "Taunt on this hero also increases Fire,Cold and Lightning resistances by 10% per charge",
              },
              {
                desc: "Taunt on this hero also increases Holy, Shadow and Mind resistances by 10% per charge",
              },
            ],
          },
        ],
      },
    ],
  },

  elePerks: {
    columns: [
      {
        name: "powerful",
        normal: [{ id: 2, desc: "Chargest that you apply +1" }],
        golden: [],
        special: [
          {
            id: 6,
            desc: "Choose one of the following perks",
            opts: [
              { desc: "Chargest that you apply +1" },
              {
                desc: "Powerful maximum charges on this hero increased by 2. Charges are instead reduced by 1 at the end of the turn",
              },
              {
                desc: "Powerful on this hero increases damage and healing done by 10% per charge and loses all charges at the end of the turn.",
              },
            ],
          },
        ],
      },
      {
        name: "burn",
        normal: [{ id: 1, desc: "Chargest that you apply +1" }],
        golden: [{ id: 3, desc: "Chargest that you apply +1" }],
        special: [
          {
            id: 5,
            desc: "Choose one of the following perks",
            opts: [
              { desc: "Chargest that you apply +1" },
              {
                desc: "Burn on this hero also increases Speed by 1 per 8 charges and instead reduces Fire resistance by 0.3% per charge",
              },
              {
                desc: "Burn on enemies deals Cold damage and reduces Fire and Cold resistance by 0.3 per charge",
              },
            ],
          },
        ],
      },
      {
        name: "fire",
        normal: [
          { id: 0, desc: "Fire +1 damage" },
          { id: 2, desc: "Fire +1 damage" },
        ],
        golden: [{ id: 4, desc: "Fire +2 damage" }],
        special: [],
      },
      { name: "empty", normal: [], golden: [], special: [] },
      {
        name: "chill",
        normal: [{ id: 1, desc: "Chargest that you apply +1" }],
        golden: [{ id: 3, desc: "Chargest that you apply +1" }],
        special: [
          {
            id: 5,
            desc: "Choose one of the following perks",
            opts: [
              { desc: "Chargest that you apply +1" },
              {
                desc: "Chill on enemies also reduces Blunt resistance by 0.3% per charge",
              },
              {
                desc: "Chill on enemies instead recduces spped by 1 per 4 charges",
              },
              {
                desc: "Chill on this hero instead reduces Speed by 1 per 8 charges and also grants 1 Reinforce per 14 charges at the end of the turn",
              },
            ],
          },
        ],
      },
      {
        name: "cold",
        normal: [
          { id: 0, desc: "Cold +1 damage" },
          { id: 2, desc: "Cold +1 damage" },
        ],
        golden: [{ id: 4, desc: "Cold +2 damage" }],
        special: [],
      },
      {
        name: "wet",
        normal: [{ id: 2, desc: "Chargest that you apply +1" }],
        golden: [],
        special: [
          {
            id: 6,
            desc: "Choose one of the following perks",
            opts: [
              {
                desc: "Wet on enemies also increases the cold damage taken by 1 per charge",
              },
              {
                desc: "Wet on enemies also reduces Lightning resistance by 1% per charge and does not lose charges at the end of the turn",
              },
              {
                desc: "Wet on heroes instead prevents 3 Burn charges per charge and does not lose charges at the end of the turn",
              },
            ],
          },
        ],
      },
      {
        name: "spark",
        normal: [{ id: 1, desc: "Chargest that you apply +1" }],
        golden: [{ id: 3, desc: "Chargest that you apply +1" }],
        special: [
          {
            id: 5,
            desc: "Choose one of the following perks",
            opts: [
              { desc: "Chargest that you apply +1" },
              {
                desc: "Spark on enemies also applies 30% of its charges as Spark charges to the sides, ath the start of the turn",
              },
              {
                desc: "Spark on enemies also applies 1 Slow per 14 charges at the end of the turn",
              },
            ],
          },
        ],
      },
      {
        name: "lightning",
        normal: [
          { id: 0, desc: "Lightning +1 damage" },
          { id: 2, desc: "Lightning +1 damage" },
        ],
        golden: [{ id: 4, desc: "Lightning +2 damage" }],
        special: [],
      },
      {
        name: "inspire",
        normal: [],
        golden: [],
        special: [
          {
            id: 6,
            desc: "Choose one of the following perks",
            opts: [
              { desc: "This hero gains 1 inspire at the start of the combat" },
              {
                desc: "Inspire maximum charges on this hero are 1, but Inspire draws 2 cards at the start of the turn",
              },
              { desc: "This hero is immune to Stress" },
            ],
          },
        ],
      },
      {
        name: "shield",
        normal: [
          { id: 0, desc: "Chargest that you apply +1" },
          { id: 1, desc: "Chargest that you apply +1" },
          { id: 3, desc: "Chargest that you apply +1" },
          { id: 4, desc: "Chargest that you apply +1" },
        ],
        golden: [
          { id: 2, desc: "Chargest that you apply +2" },
          { id: 5, desc: "Chargest that you apply +3" },
        ],
        special: [],
      },
      {
        name: "insulate",
        normal: [],
        golden: [
          {
            id: 2,
            desc: "This hero gains 1 Insulate at the start of the combat. Insulate on this hero cannot be purget unless specified.",
          },
        ],
        special: [
          {
            id: 4,
            desc: "Choose one of the following perks",
            opts: [
              { desc: "Chargest that you apply +1" },
              {
                desc: "Insulate on heroes instead increases the Fire, Cold and Lightning resistances by 35",
              },
              {
                desc: "Insulate on this hero can stack and insterad increases the Fire, Cold and Lightning resistance by 5% per charge. Maximum charges are 10",
              },
            ],
          },
        ],
      },
    ],
  },

  mysPerks: {
    columns: [
      {
        name: "vitality",
        normal: [{ id: 2, desc: "Chargest that you apply +1" }],
        golden: [],
        special: [
          {
            id: 6,
            desc: "Choose one of the following perks",
            opts: [
              {
                desc: "Vitality on this hero instead increases Max HP by 8 per charge",
              },
              { desc: "When this hero gains Vitality, removes Bleed" },
              {
                desc: "Vitality on heroes also increases Mind resistance by 0.5% per charge and does not lose charges at the start of the turn",
              },
            ],
          },
        ],
      },
      {
        name: "sanctify",
        normal: [{ id: 1, desc: "Chargest that you apply +1" }],
        golden: [{ id: 3, desc: "Chargest that you apply +1" }],
        special: [
          {
            id: 5,
            desc: "Choose one of the following perks",
            opts: [
              { desc: "Chargest that you apply +1" },
              {
                desc: "Sanctify on enemies reduces Holy resistance by 1.5% per charge",
              },
              {
                desc: "When this hero hits a monster with Sanctify it also deals 25% of the target's Sanctify charges as Holy damage",
              },
            ],
          },
        ],
      },
      {
        name: "holy",
        normal: [
          { id: 0, desc: "Holy +1 damage" },
          { id: 2, desc: "Holy +1 damage" },
        ],
        golden: [{ id: 4, desc: "Holy +2 damage" }],
        special: [],
      },
      {
        name: "decay",
        normal: [{ id: 2, desc: "Chargest that you apply +1" }],
        golden: [],
        special: [
          {
            id: 6,
            desc: "Choose one of the following perks",
            opts: [
              { desc: "Chargest that you apply +1" },
              {
                desc: "Decay on enemies instead decreases healing received by 75%",
              },
              {
                desc: "Decay on enemiesa also reduces Shadow resistance by 5% per charge",
              },
            ],
          },
        ],
      },
      {
        name: "dark",
        normal: [{ id: 1, desc: "Chargest that you apply +1" }],
        golden: [{ id: 3, desc: "Chargest that you apply +1" }],
        special: [
          {
            id: 5,
            desc: "Choose one of the following perks",
            opts: [
              { desc: "Charges that you apply +1" },
              { desc: "Dark on this hero explodes at 35 charges" },
              { desc: "Dark explosion on enemies deals 25% more damage" },
              {
                desc: "Dark charges on enemies also explode at the end of the turn",
              },
            ],
          },
        ],
      },
      {
        name: "shadow",
        normal: [
          { id: 0, desc: "Shadow +1 damage" },
          { id: 2, desc: "Shadow +1 damage" },
        ],
        golden: [{ id: 4, desc: "Shadow +2 damage" }],
        special: [],
      },
      {
        name: "regeneration",
        normal: [{ id: 2, desc: "Chargest that you apply +1" }],
        golden: [],
        special: [
          {
            id: 6,
            desc: "Choose one of the following perks",
            opts: [
              {
                desc: "Regeneration on this hero also heals the heroes at their side",
              },
              {
                desc: "Regeneration on heroes also increases healing received by 1% per charge",
              },
              {
                desc: "Regeneration on heroes also increases Shadow resistance by 0.5% per charge and does not lose charges at the start of the turn",
              },
            ],
          },
        ],
      },
      {
        name: "insane",
        normal: [{ id: 1, desc: "Chargest that you apply +1" }],
        golden: [{ id: 3, desc: "Chargest that you apply +1" }],
        special: [
          {
            id: 5,
            desc: "Choose one of the following perks",
            opts: [
              { desc: "Chargest that you apply +1" },
              {
                desc: "Insane on enemies also reduces their Max HP by 2 per charge",
              },
              {
                desc: "Insane on heroes instead reduces Mind resistance by 0.5% per charge and damage done by 0.3% per charge",
              },
            ],
          },
        ],
      },
      {
        name: "mind",
        normal: [
          { id: 0, desc: "Mind +1 damage" },
          { id: 2, desc: "Mind +1 damage" },
        ],
        golden: [{ id: 4, desc: "Mind +2 damage" }],
        special: [],
      },
      {
        name: "stanza/bless",
        normal: [{ id: 4, sub: "bless", desc: "Chargest that you apply +1" }],
        golden: [],
        special: [
          {
            id: 2,
            desc: "Choose one of the following perks",
            sub: "stanza",
            opts: [
              {
                desc: "Stanza on heroes increases all damage instead of only Mind damage",
              },
              {
                desc: "Stanza I on this hero also gives 1 Inspire at the end of the turn",
              },
              { desc: "This hero can't gain Stanza III" },
            ],
          },
          {
            id: 6,
            desc: "Choose one of the following perks",
            sub: "bless",
            opts: [
              {
                desc: "Bless on this hero increases damage done by 1.5 per charge but no longer increases healing received",
              },
              {
                desc: "Bless on this hero also increases healing done by 1% per charge",
              },
              {
                desc: "Bless on heroes also increases Holy resistance by 0.5% per charge and does not lose charges at the end of the turn",
              },
            ],
          },
        ],
      },
      {
        name: "heal",
        normal: [
          { id: 0, desc: "Heal done +1" },
          { id: 1, desc: "Heal done +1" },
          { id: 3, desc: "Heal done +1" },
          { id: 4, desc: "Heal done +1" },
        ],
        golden: [
          { id: 2, desc: "Heal done +2" },
          { id: 5, desc: "Heal done +3" },
        ],
        special: [],
      },
      {
        name: "courage",
        normal: [],
        golden: [
          {
            id: 2,
            desc: "This hero gains 1 Courage at the start of the combat. Courage on this hero cannot be purget unless specified.",
          },
        ],
        special: [
          {
            id: 4,
            desc: "Choose one of the following perks",
            opts: [
              { desc: "Chargest that you apply +1" },
              {
                desc: "Courage on heroes instead increases the Holy, Shadow and Mind resistances by 35%",
              },
              {
                desc: "Courage on this hero can stack and instead increases Holy, Shadow and Mind resistances by 5% per charge. Maximum charges are 10",
              },
            ],
          },
        ],
      },
    ],
  },
};

export const heroClasses = ["healer", "warrior", "scout", "mage"];

export const heroes = {
  warrior: ["magnus", "heiner", "grukli", "bree"],
  scout: ["andrin", "thuls", "sylvie", "gustav"],
  mage: ["evelyn", "cornelius", "wilbur", "zek"],
  healer: ["reginald", "ottis", "malukah", "nezglekt"],
  all: function () {
    return [...this.warrior, ...this.scout, ...this.mage, ...this.healer];
  },
};
